module.exports = __webpack_public_path__ + "media/images/img_service_merit_3_1-f8eae7a6b9bd41c85f089e9401a19cb7.png";